import { Component } from '@angular/core';

@Component({
  selector: 'app-header-multi-language',
  templateUrl: './header-multi-language.component.html',
  styleUrls: ['./header-multi-language.component.scss']
})
export class HeaderMultiLanguageComponent {
  
  headerlinksSpanish: { label: string, url: string }[] = [{ label: "Descargar", url: "/download" }, { label: "Ayudar", url: "https://macmillaneducation.secure.force.com/help/bg_productdetail?id=01t4H000006R8q0QAC&language=en_US&retURL=https%3A%2F%2Fmacmillaneducation.secure.force.com%2Fhelp%2Fbg_homepage%3Ffilter%3Daltura%26language%3Den_US%26sortBy%3DPopularity" }];
  headerlinksHindi: { label: string, url: string }[] = [{ label: "डाउनलोड", url: "/download" }, { label: "मदद", url: "https://macmillaneducation.secure.force.com/help/bg_productdetail?id=01t4H000006R8q0QAC&language=en_US&retURL=https%3A%2F%2Fmacmillaneducation.secure.force.com%2Fhelp%2Fbg_homepage%3Ffilter%3Daltura%26language%3Den_US%26sortBy%3DPopularity" }];

}
